import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './core/contexts/AuthContext';
import ProfileSetup from './shared/auth/ProfileSetup';
import { HomePage } from './features/home';
import { WordleGame, Leaderboard } from './features/wordle';
import { CampusGuesser, AdminPanel } from './features/campus-guesser';
import { trackPageView } from './core/utils/analytics';
import './App.css';

function AppContent() {
  const { needsProfileSetup, refreshUserProfile } = useAuth();
  const location = useLocation();

  // Track page views on route changes
  useEffect(() => {
    const pageName = location.pathname === '/' ? 'home' : location.pathname.substring(1);
    trackPageView(pageName, { path: location.pathname });
  }, [location]);

  // Show ProfileSetup modal if user has Firebase Auth but no Firestore profile
  if (needsProfileSetup) {
    return <ProfileSetup onProfileCreated={refreshUserProfile} />;
  }

  return (
    <div className="App">
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<HomePage />} />

        {/* Game routes - authentication handled by components */}
        <Route path="/game" element={<WordleGame />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/campus-guesser" element={<CampusGuesser />} />
        <Route path="/campus-admin" element={<AdminPanel />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
